import { Outlet, ScrollRestoration, useParams, useNavigate } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import useSession from '@/hooks/useSession'
import Header from '@components/Header'
import Footer from '@components/Footer'
import SocialSection from '@components/SocialSection'

import { getSignInURL } from '@/util/helpers'

export default function MainLayout() {
  const { session } = useSession()
  const { schoolSlug } = useParams()
  const navigate = useNavigate()

  if (!session?.accessToken) {
    let signinUrl = getSignInURL(schoolSlug)
    if (schoolSlug === 'undefined') {
      // TODO: this is used to search for a bug.
      Sentry.logger.error('School slug is string "undefined" in MainLayout')
      signinUrl = getSignInURL(undefined)
    }

    navigate(signinUrl)
  }

  return (
    <>
      <main className=''>
        <Header />
        <div id='content' className='py-8 flex flex-col w-full sm:px-4 md:w-5/6 lg:w-3/4 mx-auto grow'>
          <Outlet />
          <ScrollRestoration />
          <SocialSection />
        </div>
        <Footer />
      </main>
    </>
  )
}
